import { Controller } from 'stimulus';
export default class extends Controller {
  connect() {}

  onBeforeDeleteImage(e) {
    this.elementToDelete = e.currentTarget.closest('div');
  }

  onDeleteImage(e) {
    const [data, status, xhr] = e.detail;

    if (this.elementToDelete) {
      this.elementToDelete.parentNode.remove();
      this.elementToDelete = null;
    }
  }
}
